$('body').on('click', '.js-filter-btn_class', function() {
    var filterCurrentStage = $('.js-stage-tab-btn.active').index() + 1;
    var dataToSend = '&';
    if ($(this).hasClass('checked')) {
    }
    else {
        $('.filter-btn').removeClass('checked');
        $(this).addClass('checked');
        dataToSend=dataToSend+'class=true';
        getResult(filterCurrentStage, dataToSend);
    }
})

$('body').on('click', '.js-filter-btn_district', function() {
    var dataToSend = '&';
    var filterCurrentStage = $('.js-stage-tab-btn.active').index() + 1;
    if ($(this).hasClass('checked')) {
    }
    else {
        $(this).addClass('checked');
        dataToSend='&district=true';
        if ($('.js-filter-btn_parallel').hasClass('checked')) {
            dataToSend=dataToSend+'&with_parallel=true';
        }
        getResult(filterCurrentStage, dataToSend);
    }
})

$('body').on('click', '.js-filter-btn_parallel', function() {
    var dataToSend = '&';
    var filterCurrentStage = $('.js-stage-tab-btn.active').index() + 1;
    if ($(this).hasClass('checked')) {
        $(this).removeClass('checked');
        dataToSend=dataToSend+'with_parallel=false';
        if ($('.js-filter-btn_district').hasClass('checked')) {
            dataToSend=dataToSend+'&district=true';
        }
        if ($('.js-filter-btn_location').hasClass('checked')) {
            dataToSend=dataToSend+'&location=true';
        }
        if ($('.js-filter-btn_school').hasClass('checked')) {
            dataToSend=dataToSend+'&school=true';
        }
        getResult(filterCurrentStage, dataToSend);
    }
    else {
        $('.js-filter-btn_class').removeClass('checked');
        $(this).addClass('checked');
        dataToSend=dataToSend+'with_parallel=true';
        if ($('.js-filter-btn_district').hasClass('checked')) {
            dataToSend=dataToSend+'&district=true';
        }
        if ($('.js-filter-btn_location').hasClass('checked')) {
            dataToSend=dataToSend+'&location=true';
        }
        if ($('.js-filter-btn_school').hasClass('checked')) {
            dataToSend=dataToSend+'&school=true';
        }
        getResult(filterCurrentStage, dataToSend);
    }
})

$('body').on('click', '.js-filter-btn_location', function() {
    var dataToSend = '&';
    var filterCurrentStage = $('.js-stage-tab-btn.active').index() + 1;
    if ($(this).hasClass('checked')) {
    }
    else {
        $(this).addClass('checked');
        dataToSend=dataToSend+'location=true';
        if ($('.js-filter-btn_parallel').hasClass('checked')) {
            dataToSend=dataToSend+'&with_parallel=true';
        }
        getResult(filterCurrentStage, dataToSend);
    }
})

$('body').on('click', '.js-filter-btn_school', function() {
    var dataToSend = '&';
    var filterCurrentStage = $('.js-stage-tab-btn.active').index() + 1;
    if ($(this).hasClass('checked')) {
    }
    else {
        $(this).addClass('checked');
        dataToSend=dataToSend+'school=true';
        if ($('.js-filter-btn_parallel').hasClass('checked')) {
            dataToSend=dataToSend+'&with_parallel=true';
        }
        getResult(filterCurrentStage, dataToSend);
    }
})

$('body').on('click', '.filter-btn', function() {
    $('.result-wrap').parents('.loading').addClass('visible');
    $('.filter-btn').removeClass('checked');
    $(this).addClass('checked');
})